export class DashboardFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getProductivity(id, filters) {
    return this.instance.get(`/v1/dashboard/${id}/produtividade`, {
      params: filters || undefined,
      returnFullResponse: true,
    });
  }

  getIndicators(id, filters) {
    return this.instance.get(`/v1/dashboard/${id}/indicadores`, {
      params: filters || undefined,
      returnFullResponse: true,
    });
  }

  getLandDashboard(id, filters) {
    return this.instance.get(`/v1/dashboard/${id}/talhoes`, {
      params: filters || undefined,
      returnFullResponse: true,
    });
  }

  getShortcuts() {
    return this.instance.get('/v1/dashboard/shortcuts');
  }

  saveShortcuts(routes) {
    return this.instance.put('/v1/dashboard/shortcuts', { routes });
  }

  getCotacaoCafeHistoricoDiario() {
    return this.instance.get('/v1/cotacao-cafe/historico-diario');
  }
}

export default DashboardFactory;
